var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6641 6.38878L6.06511 13.9881L2.0131 14.8947L1.10645 13.8814L2.01185 9.93481L9.61078 2.33559C10.7301 1.21628 12.5448 1.21626 13.6641 2.33555C14.7833 3.45481 14.7834 5.26949 13.6641 6.38878ZM10.0236 7.20097L5.06158 12.1632L3.47094 12.5191L3.83264 10.9424L8.79874 5.97614L10.0236 7.20097ZM11.4378 5.78673L12.2499 4.97459C12.5881 4.63636 12.5881 4.08799 12.2499 3.74977C11.9116 3.41153 11.3632 3.41154 11.025 3.74978L10.2129 4.5619L11.4378 5.78673Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5a5c59c93299a567f7c0312c4d971eab.svg";
export { ForwardRef as ReactComponent };